module.exports = __webpack_public_path__ + "img/newsletter-img.2203db1c.jpg";